import { Capacitor } from '@capacitor/core'

// One deploy serves two production hosts: getdub.com (marketing homepage +
// merch storefront at /store) and app.getdub.com (tournament app). Links that
// cross between them must land on the right host in production, but the same
// build also runs where everything is one origin, and there cross-host links
// stay internal routes:
//   - Render previews and localhost dev (one host serves all routes)
//   - native builds (the whole site ships inside the app bundle; an absolute
//     URL would kick the user out of the app and into a browser)
function crossHostUrl(host, path) {
  if (Capacitor.isNativePlatform()) return path
  if (typeof window === 'undefined') return path
  const here = window.location.hostname
  // Already on the target host — keep navigation client-side.
  if (here === host) return path
  if (here === 'getdub.com' || here.endsWith('.getdub.com')) return `https://${host}${path}`
  // Previews / localhost serve everything on one host.
  return path
}

export const homeLink = (path = '/') => crossHostUrl('getdub.com', path)

export const appLink = (path = '/') => crossHostUrl('app.getdub.com', path)

// The storefront lives only at getdub.com/merch — from the app host this is
// a cross-host jump to the apex domain (internal on native/previews, like
// every cross-host link). shop.getdub.com is retired as a destination; old
// links to it are bounced to getdub.com before the app mounts (see main.jsx).
export const storeLink = (path = '/merch') => crossHostUrl('getdub.com', path)
